import React, { useRef } from "react";

import "../styles/components/profile/ProfileShell.css";
import "../styles/components/profile/ProfileHeaderSection.css";
import "../styles/components/profile/ProfileContentSections.css";
import "../styles/components/profile/ProfileActionPanels.css";
import ScrollToTopButton from "./scroll-to-top/ScrollToTopButton";
import useScrollToTopButton from "./scroll-to-top/useScrollToTopButton";
import ProfileActionPanels from "./profile/ProfileActionPanels";
import ProfileContentSections from "./profile/ProfileContentSections";
import ProfileHeaderSection from "./profile/ProfileHeaderSection";
import EditPostModal from "./profile/edit-post/EditPostModal";
import useProfileState from "./profile/useProfileState";

export default function Profile(props) {
  const overlayRef = useRef(null);
  const profile = useProfileState(props);
  const { isVisible, scrollToTop } = useScrollToTopButton({
    targetRef: overlayRef,
  });
  const hasDesktopShellNavbar = Boolean(props.desktopShellNavbar);
  const hasDesktopShellSidebar = Boolean(props.desktopShellSidebar);
  const hasDesktopShellRightPanel = Boolean(props.desktopShellRightPanel);
  const hasDesktopShellLayout =
    hasDesktopShellSidebar || hasDesktopShellRightPanel;

  return (
    <div className="profile-overlay" ref={overlayRef}>
      <ScrollToTopButton isVisible={isVisible} onClick={scrollToTop} />
      {hasDesktopShellNavbar ? props.desktopShellNavbar : null}
      <div
        className={
          hasDesktopShellLayout
            ? "profile-overlay__desktop-layout"
            : "profile-overlay__content"
        }
      >
        {hasDesktopShellSidebar ? (
          <aside className="profile-overlay__desktop-sidebar">
            {props.desktopShellSidebar}
          </aside>
        ) : null}

        <div className="profile-overlay__main">
          <ProfileHeaderSection
            profile={profile}
            bioEditRequest={props.bioEditRequest}
            isBioEditRequestReady={props.isBioEditRequestReady}
            onBioEditRequestConsumed={props.onBioEditRequestConsumed}
            onOpenSharedSidebar={props.onOpenSharedSidebar}
          />
          <ProfileContentSections profile={profile} />
          <ProfileActionPanels profile={profile} />
          <EditPostModal
            post={profile.editingPost}
            onClose={profile.handleCloseEditPost}
            onSaved={profile.handleEditPostSaved}
          />
        </div>

        {hasDesktopShellRightPanel ? (
          <aside className="profile-overlay__desktop-rightpanel">
            {props.desktopShellRightPanel}
          </aside>
        ) : null}
      </div>
    </div>
  );
}
